import React from "react";
import { useQuery } from "react-query";
import { getCategories } from "../api/budget";

export default function BudgetRow({
  item,
  edit,
  balance,
  onChange,
  onChangeDetail,
  onChangeAmount,
  onSave,
  onRemove,
}) {
  function convertCurrency(number) {
    return new Intl.NumberFormat().format(number);
  }

  const categoryList = useQuery({
    queryKey: "getCategories",
    queryFn: async () => await getCategories(),
  }).data;

  let options = [];
  if (categoryList && categoryList.length > 0) {
    options.push(<option selected>-</option>);
    categoryList
      .filter((t) => t.TYPE === item.TYPE)
      .forEach((c, i) => {
        options.push(
          <option key={c.ID} value={c.NAME}>
            {c.NAME}
          </option>
        );
      });
  }

  return (
    <div
      className={`w-full ${edit ? "my-1 mb-2 sm:flex-col sm:items-start" : ""}`}
      key={`${item.ID}`}
    >
      {edit ? (
        <div className="grid grid-cols-4 truncate">
          <select
            className="h-6 border border-gray-600 rounded"
            value={item.CATEGORY}
            onChange={onChange}
          >
            {options}
          </select>
          <input
            type="text"
            className="border-gray-400"
            value={item.DETAIL}
            onChange={onChangeDetail}
          />
          <span class="flex items-center sm:justify-between">
            <input
              type="number"
              className="border-gray-400"
              value={item.AMOUNT}
              onChange={onChangeAmount}
            />
            <button className="w-10 border rounded ml-2" onClick={onSave}>
              Edit
            </button>
            <button className="w-6 h-6" onClick={onRemove}>
              -
            </button>
          </span>
        </div>
      ) : (
        <div className="grid grid-cols-4 truncate">
          <span className="col-span-2 truncate">
            {item.CATEGORY}{item.DETAIL ? <span>({item.DETAIL})</span> : null}
          </span>
          <span>{convertCurrency(item.AMOUNT)}</span>
          <span>{convertCurrency(balance)}</span>
        </div>
      )}
    </div>
  );
}
